'use client';
import { BaseAds } from '@/components/Ads/BaseAds';
import { SideBarBox } from '../SideBarBox';

type Props = {
  title: string;
  ads: AdDto[];
};

export const SideBarAds: React.FC<Props> = ({ title, ads }) => {
  return (
    <>
      {ads.length > 0 && (
        <SideBarBox title={title}>
          <BaseAds ads={ads} />
        </SideBarBox>
      )}
    </>
  );
};
